import React, { useState, useEffect } from "react";
import { Button, Card, Form, Col, Table, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
  Filter,
} from "react-bs-datatable";
import { deleteTaskNumber, getTaskNumbers, importExcel } from "../../../../services/TaskNumberService";

const ListTaskNumbers = () => {
  const [tasknumbers, setTaskNumbers] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setMessage(""); // Clear previous messages
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await importExcel(formData);
      setMessage(response);
    } catch (error) {
      console.error("Upload error:", error);
      setMessage("Error uploading file.");
    }
  };

  useEffect(() => {
    fetchTaskNumbers();
  }, []);

  const fetchTaskNumbers = async () => {
    try {
      const data = await getTaskNumbers();
      setTaskNumbers(data);
    } catch (error) {
      console.error("Error fetching task numbers:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteTaskNumber({ id });
      fetchTaskNumbers(); // Refresh list after deletion
      console.log("Task number deleted successfully");
    } catch (error) {
      console.error("Error deleting task number:", error);
    }
  };

  // Table header configuration
  const header = [
    { prop: "employeeId", title: "Employee Id" },
    { prop: "fullName", title: "Employee Name" },
    { prop: "taskNumbers", title: "Task Number" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={`/settings/task-number/edit/${row._id}`}
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Link
            to={`/settings/task-number/view/${row._id}`}
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-eye"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data to match the table format (if necessary)
  const tableData = tasknumbers.map((tasknumber) => ({
    employeeId: tasknumber.employeeId,
    fullName: tasknumber.fullName,
    taskNumbers: tasknumber.taskNumbers.join(", "),
    _id: tasknumber._id, // Add this for the actions to work
  }));

  // Filter the data based on employeeId
  const filteredData = tableData.filter((item) =>
    item.fullName?.toString().toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div>
      <Card>
        <Card.Body>
        <h1>Task number of Employees</h1>
          <Row className="mb-4">
            <Col
              md={3}
              lg={3}
             className="d-flex flex-col justify-content-end align-items-end"
            >
              <Form.Control
                type="text"
                placeholder="Search by Employee Name"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
            <Col md={7} lg={7}>
              <Form className="d-flex align-items-center">
                <Form.Group controlId="formFile" className="mb-0 mr-2">
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "inline-block", width: "auto" }}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  onClick={handleUpload}
                  className="ml-2"
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                >
                  Upload
                </Button>
                {message && (
                  <span className="" style={{ marginLeft: "10px" }}>
                    {message}
                  </span>
                )}
              </Form>
            </Col>
            <Col md={2} lg={2} className="d-flex justify-content-end">
              <Link
                to="/settings/task-number/add"
                className="d-flex justify-content-end mb-4"
              >
                <Button>Add Task Number</Button>
              </Link>
            </Col>
          </Row>

          <DatatableWrapper
            body={filteredData} // Use filtered data for the table
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 5, // Set rows per page
                options: [5, 10, 15], // Options for rows per page
              },
            }}
          >
            <Table>
              <TableHeader />
              <TableBody />
            </Table>
            <Row>
              <Col className="d-flex flex-col justify-content-start">
                <PaginationOptions />
              </Col>
              <Col className="mt-4 d-flex flex-col justify-content-end align-items-end">
                <Pagination />
              </Col>
            </Row>
          </DatatableWrapper>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListTaskNumbers;
